import { useMemo } from 'react';
import { usePlan } from '../store/planStore.js';
import { mealCatalogue, type MealCatalogue } from './catalogue.js';

export function useMeals(): MealCatalogue {
  const { library } = usePlan();
  return useMemo(() => mealCatalogue(library.customMeals), [library.customMeals]);
}
